module.exports = __webpack_public_path__ + "static/media/dxf.cb0fab85.png";